import { WindowManager } from '@kurtosys/window-manager';
import { EventTypes } from './models/EventTypes.js';
export class SourceEventManager {
    constructor(sourceKey) {
        this.subs = new Map();
        this.key = sourceKey;
    }
    getSubscribers(type) {
        if (!this.subs || !this.isValidType(type)) {
            return [];
        }
        return this.subs.get(type) || [];
    }
    subscribe(subscription) {
        const { type, listener } = subscription;
        if (!type || !this.isValidType(type) || !listener || !this.getListenerKey(listener)) {
            return;
        }
        const existingSubscribers = this.getSubscribers(type);
        const existingSubscription = existingSubscribers.find((existingSubscription) => this.getListenerKey(existingSubscription.listener) === this.getListenerKey(listener));
        if (!existingSubscription) {
            this.pushSubscribers(subscription);
        }
    }
    unsubscribe(type, listener) {
        if (!this.isValidType(type)) {
            return;
        }
        const existingSubscribers = this.getSubscribers(type);
        if (existingSubscribers.length > 0) {
            const updatedSubscribers = existingSubscribers.reduce((list, item) => {
                if (this.getListenerKey(item.listener) !== this.getListenerKey(listener)) {
                    list.push(item);
                }
                return list;
            }, []);
            this.setSubscribers(type, updatedSubscribers);
        }
    }
    publish(source, detail) {
        const { type } = detail;
        if (!this.isValidType(type)) {
            console.error('SourceEventManager: Invalid Event Type', type);
            return;
        }
        const eventKey = this.getEventKey(type); // TODO: will be used to improve logging.
        const subscribers = this.getSubscribers(type);
        if (subscribers) {
            subscribers.forEach((subscriber) => {
                if (this.getListenerKey(subscriber.listener) !== SourceEventManager.generateKey(source)) {
                    subscriber.onPublish({
                        detail,
                        source,
                    });
                }
            });
        }
        // Add event details to window storage
        const eventDetails = WindowManager.has('eventDetails') ? WindowManager.get('eventDetails') : {};
        eventDetails[this.key] = {
            ...eventDetails[this.key],
            [type]: detail,
        };
        WindowManager.set('eventDetails', eventDetails);
    }
    pushSubscribers(sub) {
        const existing = this.getSubscribers(sub.type);
        this.subs.set(sub.type, [...existing, sub]);
    }
    setSubscribers(type, subs) {
        const workingSubs = subs.filter((sub) => sub.type === type);
        this.subs.set(type, workingSubs);
    }
    isValidType(type) {
        return Object.values(EventTypes).includes(type);
    }
    getListenerKey(listener) {
        return SourceEventManager.generateKey(listener);
    }
    getEventKey(type) {
        return `${this.key}-${type}`;
    }
    static generateKey(eventSource, disableAppId = false) {
        const sourceKeyOrder = [
            'templateId',
            'applicationCode',
            'configurationKey',
            'styleKey',
            'applicationId',
        ];
        return sourceKeyOrder.reduce((finalKey, sourceKey) => {
            if (sourceKey === 'applicationId' && disableAppId) {
                return finalKey;
            }
            const defaultValue = sourceKey === 'configurationKey' || sourceKey === 'styleKey' ? 'default' : undefined;
            return SourceEventManager.generateKeyPart(finalKey, eventSource[sourceKey], defaultValue);
        }, '');
    }
    static generateKeyPart(currentString, value, defaultValue) {
        const workingValue = value || defaultValue;
        if (!workingValue) {
            return currentString;
        }
        if (currentString) {
            return `${currentString}-${workingValue}`;
        }
        return workingValue;
    }
}
//# sourceMappingURL=SourceEventManager.js.map